import React from 'react';

import AiSparklesIcon from 'icons/ai-sparkles.svg';

const InfoPopover = ({ isOpen, onLinkClicked, onCloseClicked }) => {
  return (
    <div id="infoPopover" popover="auto" className={isOpen ? 'is-open' : undefined} data-testid={'popover'}>
      <div className="infoPopover-title">What is Sentiment Analysis?</div>
      <div className="infoPopover-inner">
        <div className="infoPopover-note">
          <div>
            <AiSparklesIcon />
          </div>
          <div>
            <p>
              This feature uses AI to assign sentiment scoring to posts that mention research. Although the quality of
              AI outputs is often high, they may contain incorrect information. The validity of the output should be
              verified by reviewing the referenced documents.
            </p>
            <a
              onClick={onLinkClicked}
              href="https://help.altmetric.com/en/articles/10026177"
              target="_blank"
              rel="noreferrer"
            >
              Learn more about Sentiment Analysis
            </a>
          </div>
        </div>
        <div className="infoPopover-body">
          <p>
            We use Sentiment Analysis to provide insight into the kind of attention your research has accrued. Using an
            AI model we can apply a sentiment rating to each mention on a scale from strong positive to strong negative
            depending on the content and context of the post. This gives you a better understanding of what people are
            saying about your research.
          </p>
        </div>
        <div className="infoPopover-footer">
          <div className="infoPopover-buttons">
            <button
              type="button"
              className="close"
              onClick={onCloseClicked}
              popovertarget="infoPopover"
              popovertargetaction="close"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoPopover;
